import { updates } from '@/mocks/home';

const badgeStyles: Record<string, string> = {
  hot: 'bg-primary-500/15 text-primary-400',
  new: 'bg-accent-500/15 text-accent-400',
  info: 'bg-secondary-500/15 text-secondary-400',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">更新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">最新上架内容与平台动态，第一时间掌握精彩</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200 last:border-b-0 group cursor-pointer"
            >
              <div className="flex-shrink-0 mt-1">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 group-hover:scale-125 transition-transform"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-700 group-hover:text-foreground-900 transition-colors leading-relaxed">
                  {item.title}
                </p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full whitespace-nowrap ${badgeStyles[item.badge] || badgeStyles.info}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}